import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from 'vuex'

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/Layout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/spots',
        name: 'Spots',
        component: () => import('@/views/Spots.vue')
      },
      {
        path: '/spot/:id',
        name: 'SpotDetail',
        component: () => import('@/views/SpotDetail.vue')
      },
      {
        path: '/recommendations',
        name: 'Recommendations',
        component: () => import('@/views/Recommendations.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/knowledge-graph',
        name: 'KnowledgeGraph',
        component: () => import('@/views/KnowledgeGraph.vue')
      },
      {
        path: '/compare',
        name: 'Compare',
        component: () => import('@/views/Compare.vue')
      },
      {
        path: '/route-planning',
        name: 'RoutePlanning',
        component: () => import('@/views/RoutePlanning.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/travel-notes',
        name: 'TravelNotes',
        component: () => import('@/views/TravelNotes.vue')
      },
      {
        path: '/notes/:id',
        name: 'NoteDetail',
        component: () => import('@/views/NoteDetail.vue')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/favorites',
        name: 'Favorites',
        component: () => import('@/views/Favorites.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const store = useStore()
  if (to.meta.requiresAuth && !store.state.token) {
    next('/login')
  } else {
    next()
  }
})

export default router
